import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {InstitutionUnit} from "../../models/Institution-unit";
import Helpers from "../../utils/helpers";

@Injectable()
export class UnitControllerService {

  private baseUrl: string = environment.PARTC_URL;
  private keycloakBaseUrl: string = environment.KEYCLOAK_URL + "admin/realms/" + environment.KEYCLOAK_REALM;
  constructor(private http: HttpClient) {
  }

  // not used in keycloak flow
  public createInstitutionUnit(institutionUnit: InstitutionUnit) {
    Helpers.trimRecursiveObj(institutionUnit);
    const body = JSON.stringify(institutionUnit);
    return this.http.put(this.baseUrl + "institution/" + institutionUnit.institution_id + "/unit", body, {responseType: "text"});
  }

  // not used in keycloak flow
  public getInstitutionUnit(institutionId: string, unitId: string) {
    return this.http.get(this.baseUrl + "institution/" + institutionId + "/unit/" + unitId);
  }

  // not used in keycloak flow
  public getInstitutionUnits(institutionId: string) {
    return this.http.get(this.baseUrl + "institution/" + institutionId + "/unit");
  }

  // not used in keycloak flow
  public updateInstitutionUnit(institutionUnit: InstitutionUnit) {
    Helpers.trimRecursiveObj(institutionUnit);
    const body = JSON.stringify(institutionUnit);
    return this.http.post(this.baseUrl + "institution/" + institutionUnit.institution_id + "/unit/" + institutionUnit.id, body);
  }

  public deleteInstitutionUnit(institutionUnit: InstitutionUnit) {
    if (Boolean(environment.KEYCLOAK_ACTIVE)) {
      return this.http.delete(this.keycloakBaseUrl + "/groups/" + institutionUnit.id);
    }
    return this.http.delete(this.baseUrl + "institution/" + institutionUnit.institution_id + "/unit/" + institutionUnit.id);
  }

}
